import JSZip from 'jszip';
import { PathHolder } from '../util/path-utils';

export class ZipHelper {
  readonly #jszip: JSZip;

  constructor() {
    this.#jszip = new JSZip();
  }

  addBlob = (blob: Blob, ...filePathSegments: string[]): this => {
    const filePath = PathHolder.from(filePathSegments).path;
    this.#jszip.file(filePath, blob, { createFolders: true });
    return this;
  };

  serialize = async (): Promise<Blob> => {
    const ZIP = this.#jszip;
    return await ZIP.generateAsync({ type: 'blob' });
  };
}
